module.exports = __webpack_public_path__ + "static/img/MRI_4.f91ccca1.jpg";